// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__t-0Ck","menu-container":"Menu_menu-container__XEPqj","show-separator":"Menu_show-separator__nbWA4"};